import React from 'react'
import { InputSwitch } from 'primereact/inputswitch'

const SwitchInput = ({
  parentClass = '',
  label,
  value,
  handleChange,
  labelClassName,
  ...rest
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-2 ${parentClass}`}>
      {label && (
        <label className={labelClassName ? labelClassName : 'input-label'}>
          {label}
        </label>
      )}
      <InputSwitch
        checked={value}
        onChange={handleChange}
        {...rest}
        pt={{
          root: { className: '!h-[20px]' },
          slider: { className: `rounded-[100px] ${value ? '!bg-primary' : ''}` }
        }}
      />
    </div>
  )
}

export default SwitchInput
